import { useEffect } from 'react';
import { useMap } from '@vis.gl/react-google-maps';

export type RecenterConfig = {
  /** Coordinate to pan to, or null to do nothing. */
  center: google.maps.LatLngLiteral | null;
  /** Only pan while true; set false during map edits so the camera holds. */
  active: boolean;
  /** Optional zoom to apply alongside the pan. */
  zoom?: number;
  /** Optional pixels to pan by once the map settles on `center`. */
  offset?: { x: number; y: number };
};

/** Pans the map to `center` when it changes while `active`. */
const RecenterListener = ({ center, active, zoom, offset }: RecenterConfig) => {
  const map = useMap();

  useEffect(() => {
    if (!map || !active || !center) {
      return undefined;
    }

    if (offset) {
      map.setCenter(center);
    } else {
      map.panTo(center);
    }

    if (zoom !== undefined) {
      map.setZoom(zoom);
    }

    if (!offset) {
      return undefined;
    }

    const listener = google.maps.event.addListenerOnce(map, 'idle', () =>
      map.panBy(offset.x, offset.y),
    );

    return () => listener.remove();
  }, [map, active, center?.lat, center?.lng, zoom, offset?.x, offset?.y]);

  return null;
};

export default RecenterListener;
